import Joi from '@hapi/joi'

export const CustomerLeafCollectionReportSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    factoryID: Joi.number().invalid(0).required().label("Factory").messages({
        "any.invalid": `Select Factory`,
        "any.required": `Factory required`
    }),
    routeID: Joi.number().allow("", null).label("Route"),
        
    searchDate: Joi.string().invalid("").required().label("Search Date"),

    collectionTypeID: Joi.number().allow("", null).label("Collection type"),
        
}